module.exports = "../dist/frontend/images/gold/carousel/payments/payments.svg?35abcd10b5d123e3e6c2b1073f004153";